import type { UserWritableAttributes } from '#shared/types/userAttributes'

export default function useUserAttributes() {
  const { $api } = useNuxtApp()
  const userStore = useUserStore()

  /**
   * Updates the current user's attributes.
   *
   * Only the writable keys defined in `shared/types/userAttributes.ts` are accepted.
   *
   * @param attributes The attributes to update
   */
  async function updateAttributes(attributes: UserWritableAttributes) {
    await $api('/api/users/me', {
      method: 'PATCH',
      body: { attributes },
    })

    userStore.$patch(state => {
      Object.assign(state.attributes, attributes)
    })
  }

  return { updateAttributes }
}
